import { Input } from './Input'

export const InputNumber = Input
